import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Chip,
  Stack,
  Avatar,
  IconButton,
  useMediaQuery,
  useTheme,
  Grid,
  Grid2
} from "@mui/material";
import { ChevronLeft, ChevronRight, Star, Calendar, Group } from "@mui/icons-material";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import SocialMediaComp from "../FillerComponents/SocialMediaComp";

// Optimized Slides Data


const slides = [
  {
    badge: "Bestseller",
    title: "Himachal - The Land of Gods",
    desc: "Explore lush green valleys of Manali, Shimla, and Kasol. Perfect for families and honeymooners.",
    price: "₹ 8,499",
        exploreText: "Explore Himachal",
    route: "/himachalpradesh",
    img: "https://www.tempotravellerrentindelhi.com/blog/wp-content/uploads/2023/12/some-less-explored-destinations-of-himachal-pradesh-tour.webp",
    sideImgs: [
      "https://images.unsplash.com/photo-1548013146-72479768bada?w=150&q=60",
      "https://images.unsplash.com/photo-1606214174585-fe31582dc6ee?w=150&q=60",
    ],
  },
  {
    badge: "Pilgrimage",
    title: "Uttarakhand - Devbhoomi",
    desc: "Find serenity in Rishikesh, Nainital, and Char Dham route. A spiritual journey awaits you.",
    price: "₹ 6,999",
    img: "https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?q=80&w=2000&auto=format&fit=crop",
        exploreText: "Explore Uttarakhand",
    route: "/uttarakhand",

    sideImgs: [
      "https://images.unsplash.com/photo-1548013146-72479768bada?w=150&q=60",
      "https://images.unsplash.com/photo-1606214174585-fe31582dc6ee?w=150&q=60",
    ],
  },
  {
    badge: "Adventure",
    title: "Ladakh - The Cold Desert",
    desc: "Ride to Khardung La, camp at Pangong Lake, and experience raw beauty of Nubra Valley.",
    price: "₹ 18,500",
    exploreText: "Explore Ladakh",
    route: "/leh&ladakh",

    img: "https://limitlessindiavacations.com/wp-content/uploads/2024/07/ladakh2.jpg",
    sideImgs: [
      "https://images.unsplash.com/photo-1548013146-72479768bada?w=150&q=60",
      "https://images.unsplash.com/photo-1606214174585-fe31582dc6ee?w=150&q=60",
    ],
  },
  {
    badge: "Paradise",
    title: "Kashmir - Heaven Awaits",
    desc: "Stay in a houseboat on Dal Lake, visit Gulmarg for skiing, and explore Mughal Gardens.",
    price: "₹ 12,999",
    img: "https://www.ekashmirtourism.com/wp-content/uploads/2022/08/Shikara-boats-floating-on-Dal-Lake.jpg",
    exploreText: "Explore Jammu & Kashmir",
    route: "/jammu&kashmir",
    sideImgs: [
      "https://images.unsplash.com/photo-1548013146-72479768bada?w=150&q=60",
      "https://images.unsplash.com/photo-1606214174585-fe31582dc6ee?w=150&q=60",
    ],
  },
];

const AUTO_DELAY = 5000;

export default function HimachalHeroSlider() {
  const [index, setIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const nextSlide = () => setIndex((prev) => (prev + 1) % slides.length);
  const prevSlide = () => setIndex((prev) => (prev - 1 + slides.length) % slides.length);

  useEffect(() => {
    if (!isPaused) {
      const timer = setInterval(nextSlide, AUTO_DELAY);
      return () => clearInterval(timer);
    }
  }, [index, isPaused]);




  
const navigate = useNavigate();

const handleExplore = () => {
  navigate(slides[index].route);
};
  
  
  return (
    <Box
      sx={{
        position: "relative",
        height: { xs: "600px", md: "55vh" },
        width: "100%",
        overflow: "hidden",
        bgcolor: "#000",
      }}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      {/* --- BACKGROUND LAYER --- */}
    <AnimatePresence mode="wait">
  <motion.img
    key={slides[index].img}
    src={slides[index].img}
    alt={slides[index].title}
    initial={{ scale: 1.1, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    exit={{ scale: 1.05, opacity: 0 }}
    transition={{ duration: 1.2, ease: "easeOut" }}
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",   
    }}
  />
</AnimatePresence>

      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(to right, rgba(0, 0, 0, 0.58), rgba(0, 0, 0, 0.57))",
          zIndex: 1,
        }}
      />
      
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          px: { xs: 3, md: 8 },
          maxWidth: "xl",
          mx: "auto",
        }}
      >
        <Grid2 container spacing={2} alignItems="center">
          {/* Left: Text Content */}
          <Grid2 item xs={12} md={7}>
            <AnimatePresence mode='wait'>
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -30 }}
                transition={{ duration: 0.6 }}
              >
                <Chip
                  label={slides[index].badge}
                  size="medium"
                  sx={{
                    mb: 2,
                    backgroundColor: "#065F46",
                    color: "white",
                    fontWeight: "bold",
                    px: 1,
                    borderRadius: "4px",
                  }}
                />

                <Typography
                  variant='body2'
                  component='h6'
                  sx={{
                    color: "white",
                    fontWeight: 800,
                    mb: 2,
                    lineHeight: 1.1,
                    fontSize: { xs: "2.5rem", md: "2.5rem" },
                  }}
                >
                  {slides[index].title}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    color: "rgba(255,255,255,0.8)",
                    mb: 4,
                    maxWidth: "90%",
                    lineHeight: 1.7,
                    fontSize: { xs: "1rem", md: "1.25rem" }
                  }}
                >
                  {slides[index].desc}
                </Typography>

                {/* Price & Action */}
             <Stack
  direction="column"
  spacing={2}
  mb={4}
>
  {/* Price */}
  <Box>
    <Typography variant="caption" color="#ccc">
      Starts at
    </Typography>
    <Typography variant="h4" fontWeight={800} color="#FFD046">
      {slides[index].price}
    </Typography>
  </Box>

  {/* Buttons */}
  <Stack
    direction={{ xs: "row", sm: "row" }}
    spacing={2}
    alignItems={{ xs: "stretch", sm: "center" }}
  >
    <Button
      variant="contained"
      size="small"
      sx={{
        bgcolor: "#FFD046",
        color: "#000",
        fontWeight: 700,
        px: 2,
        borderRadius: "8px",
        whiteSpace: "nowrap",
        "&:hover": { bgcolor: "#FFC107" }
      }}
      fullWidth={{ xs: true, sm: false }}
    >
      Book Now
    </Button>

    <Button
      variant="outlined"
      size="small"
      sx={{
        borderColor: "rgba(255,255,255,0.5)",
        color: "white",
        fontWeight: 600,
        px: 2,
        borderRadius: "8px",
        whiteSpace: "nowrap",
        "&:hover": {
          borderColor: "white",
          bgcolor: "rgba(255,255,255,0.1)"
        }
      }}
      onClick={handleExplore}
      fullWidth={{ xs: true, sm: false }}
    >
      {slides[index].exploreText}
    </Button>
  </Stack>
</Stack>
 </motion.div>
            </AnimatePresence>
          </Grid2>

        </Grid2>
      </Box>

      {/* --- CONTROLS --- */}
      {/* Arrows */}
      <Box
        sx={{
          position: "absolute",
          bottom: 40,
          right: { xs: 20, md: 40 },
          display: "flex",
          gap: 1,
          zIndex: 10
        }}
      >
        <IconButton
          onClick={prevSlide}
          sx={{
            bgcolor: "rgba(255,255,255,0.1)",
            color: "white",
            backdropFilter: "blur(5px)",
            "&:hover": { bgcolor: "#FFD046", color: "#000" }
          }}
        >
          <ChevronLeft fontSize="large" />
        </IconButton>
        <IconButton
          onClick={nextSlide}
          sx={{
            bgcolor: "rgba(255,255,255,0.1)",
            color: "white",
            backdropFilter: "blur(5px)",
            "&:hover": { bgcolor: "#FFD046", color: "#000" }
          }}
        >
          <ChevronRight fontSize="large" />
        </IconButton>
      </Box>

      {/* Pagination Dots */}
      <Box
        sx={{
          position: "absolute",
          bottom: { xs: 20, md: 40 },
          left: { xs: 20, md: 40 },
          display: "flex",
          gap: 1,
          zIndex: 10
        }}
      >
        {slides.map((_, i) => (
          <Box
            key={i}
            onClick={() => setIndex(i)}
            sx={{
              width: i === index ? 24 : 8,
              height: 8,
              borderRadius: 4,
              backgroundColor: i === index ? "#FFD046" : "rgba(255,255,255,0.4)",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
          />
        ))}
      </Box>
    </Box>
  );
}
